import { RouteRecordRaw } from 'vue-router';
import AuthLayout from '@/shared/layouts/AuthLayout.vue';

export function withAuthLayout(route: RouteRecordRaw): RouteRecordRaw {
  return {
    ...route,
    meta: {
      ...route.meta,
      layout: AuthLayout,
      requiresAuth: true
    }
  };
}

export function withAuthLayoutAndRoles(route: RouteRecordRaw, roles: string[]): RouteRecordRaw {
  return {
    ...route,
    meta: {
      ...route.meta,
      layout: AuthLayout,
      requiresAuth: true,
      requiredRoles: roles
    }
  };
} 